import { apiAxios } from '@/lib/apiAxios';
export const fetchInternalUsers = async () => apiAxios
    .get('/internal/users')
    .then((response) => response.data.data);
export const lookupInternalUser = async (email) => apiAxios
    .get('/internal/users/lookup', { params: { email } })
    .then((response) => response.data);
export const grantInternalRole = async (params) => apiAxios
    .post('/internal/users/grant-role', params)
    .then((response) => response.data);
export const revokeInternalRole = async (params) => apiAxios
    .post('/internal/users/revoke-role', params)
    .then((response) => response.data);
